import * as React from 'react';
import { Route, Redirect, RouteProps, matchPath, useLocation } from 'react-router';
import { session } from '../../utils/auth';
import { initialRoute } from '../../utils/initialRoute';
import { useGetProfile } from '../../utils/useGetProfile';

type PrivateRouteProps = RouteProps & {
  to?: string;
};

const PrivateRoute: React.FC<PrivateRouteProps> = ({ to = '/inicio-sesion', ...props }) => {
  const { loading } = useGetProfile();
  const { pathname } = useLocation();
  const match = matchPath(pathname, props);

  // with this we prevent the behavior "hit and clear" of the `initialRoute`
  React.useEffect(() => {
    if (!match || !session.accessToken || loading) return () => {};

    const timeout = setTimeout(() => {
      initialRoute.clearIf(pathname);
    }, 500);

    return () => clearTimeout(timeout);
  }, [ match, loading, pathname ]);

  if (!match) return null;

  // no auth
  if (!session.accessToken) {
    initialRoute.set(pathname);
    return <Redirect to={to} />;
  }

  if (loading) return null;

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Route {...props} />;
};

export default PrivateRoute;
